import axios from 'axios';
// import moment from 'moment';
// import store from '../store';

function errorHandler(error, reject) {
    // console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

function get() {
    return new Promise(async (resolve, reject) => {
        try {
            const { data } = await axios.get(`consolperiode`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
}

function closing(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const { data } = await axios.post("consolperiode", obj);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}

function set(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const { data } = await axios.post("consolperiode/setcurrent", obj);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}

export default {
    get, 
    closing,
    set
};